import axios from 'axios';

export default async function createGroup(
  accessToken,
  name,
  icon,
  created_by = null,
) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_GROUPS_API_URL}`,
      created_by ? { name, icon, created_by } : { name, icon },
      requestOptions,
    );

    console.log(data);
    return data;
  } catch (err) {
    console.log(err);
    return err;
  }
}
